import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { MODAL_QUERY_NM } from './modal';
import { authExpired, getLocalStorage,  } from './auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const contextPath = '/project';
const queryName = 'PROJECT_POINT';

export const useGetProjectPointList = (sid) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_LIST`], 
                () => getProjectPointList(sid, authInfo && authInfo.accessToken),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjectPointList = async (sid, accessToken) => {
    if(sid && sid!==null){
        const url = contextPath+'/pointList/'+sid;
        const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

        return retVal;
    }
}

export const useSetProjectPoint = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                case 'PUT':
                    return putProjectPoint(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteProjectPoint(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putProjectPoint(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_LIST`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const putProjectPoint = async (param, accessToken) => {

    const sendParam = {
        tid: param.tid,
        sid: param.sid,
        rtid: param.rtid,
        sno: param.sno,
        snm: param.snm,
        point_tp: param.point_tp,
        way_cnt: param.way_cnt,
        // dir_cnt: param.dir_cnt,
        descr: param.descr,
        pos_addr: param.pos_addr,
        pos_gps: param.pos_gps,
        pos_etc: param.pos_etc,
        file_img: param.file_img,
        file_etc: param.file_etc,
        is_cod: param.is_cod,
        is_run: param.is_run
    }

    const retVal = await instance.post(contextPath+'/point', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectPoint = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/point/'+param.tid,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useGetProjectPointInputTimeList = (tid) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_INPUT_TIME_LIST`], 
                () => getProjectPointInputTimeList(tid, authInfo && authInfo.accessToken),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjectPointInputTimeList = async (tid, accessToken) => {
    if(tid && tid!==null){
        const url = contextPath+'/pointInputTimeTable/'+tid;
        const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

        return retVal;
    }
}

export const useSetProjectPointInputTimeTable = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postProjectPointInputTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                case 'PUT':
                    return putProjectPointInputTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DATE_INIT':
                    return putProjectPointInputTimeTableByDate(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteProjectPointInputTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putProjectPointInputTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_INPUT_TIME_LIST`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postProjectPointInputTimeTable = async (param, accessToken) => {

    const sendParam = {
        tid: param.tid,
        sdate: param.sdate,
        stime: param.stime,
        etime: param.etime,
    }

    const retVal = await instance.post(contextPath+'/pointInputTimeTable', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putProjectPointInputTimeTable = async (param, accessToken) => {

    const sendParam = {
        seqArr: param.seqArr,
        is_cod: param.is_cod,
    }

    const retVal = await instance.put(contextPath+'/pointInputTimeTable', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putProjectPointInputTimeTableByDate = async (param, accessToken) => {

    const sendParam = {
        sid: param.sid,
        sdate: param.sdate,
        tid: param.tid
    }

    const retVal = await instance.put(contextPath+'/pointInputTimeTableByDate', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectPointInputTimeTable = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/pointInputTimeTable/'+param.tid+'/'+param.sdate,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useGetProjectPointSetupTimesetList = (tid) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_SETUP_TIMESET_LIST`], 
                () => getProjectPointSetupTimesetList(tid, authInfo && authInfo.accessToken),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjectPointSetupTimesetList = async (tid, accessToken) => {

    if(tid && tid!==null){
        const url = contextPath+'/pointSetupTimeset/'+tid;
        const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

        return retVal;
    }
}

export const useSetProjectSetupTimeTable = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'POST':
                    return postProjectSetupTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                case 'PUT':
                    return putProjectSetupTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DELETE':
                    return deleteProjectSetupTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putProjectSetupTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_SETUP_TIMESET_LIST`], { refetchInactive: true })
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postProjectSetupTimeTable = async (param, accessToken) => {

    const sendParam = {
        tid: param.tid,
        sdate: param.sdate,
        stime: param.stime,
        etime: param.etime,
    }

    const retVal = await instance.post(contextPath+'/pointSetupTimeset', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putProjectSetupTimeTable = async (param, accessToken) => {

    const sendParam = {
        seq: param.seq,
        sdate: param.sdate,
        stime: param.stime,
        etime: param.etime,
    }

    const retVal = await instance.put(contextPath+'/pointSetupTimeset', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectSetupTimeTable = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/pointSetupTimeset/'+param.seqArr,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}


export const useSetProjectTimeInit = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'ALL':
                    return putProjectAllTimeInit(sendParam, authInfo ? authInfo.accessToken:'');
                case 'SETUP':
                    return putProjectSetupTimeInit(sendParam, authInfo ? authInfo.accessToken:'');
                case 'INPUT':
                    return putProjectInputTimeInit(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return putProjectSetupTimeTable(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_SETUP_TIMESET_LIST`], { refetchInactive: true });
                queryClient.invalidateQueries([`${queryName}_INPUT_TIME_LIST`], { refetchInactive: true });
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const putProjectAllTimeInit = async (param, accessToken) => {

    const retVal = await instance.put(contextPath+'/point/timeInit/'+param.sid+'/'+param.tid, {},{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putProjectSetupTimeInit = async (param, accessToken) => {

    const retVal = await instance.put(contextPath+'/point/setupTimeInit/'+param.tid, {},{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putProjectInputTimeInit = async (param, accessToken) => {

    const retVal = await instance.put(contextPath+'/point/inputTimeInit/'+param.sid+'/'+param.tid, {},{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

export const useGetProjectCounter = (tid) => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_POINT_COUNTER_LIST`], 
                () => getProjectPointCounterList(tid, authInfo && authInfo.accessToken),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getProjectPointCounterList = async (tid, accessToken) => {

    if(tid && tid!==null){
        const url = contextPath+'/pointCounter/'+tid;
        const retVal = await instance.get(url, {headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

        return retVal;
    }
}

export const useSetProjectPointerCounter = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useMutation(
        (sendParam) => {
            switch(sendParam.mode){
                case 'AUTO':
                    return postProjectPointCounterAuto(sendParam, authInfo ? authInfo.accessToken:'');
                case 'POST_COUNTER':
                    return postProjectPointCounter(sendParam, authInfo ? authInfo.accessToken:'');
                case 'CLEAR':
                    return deleteProjectPointCounterClear(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DEL_GROUP':
                    return deleteProjectPointCounterGroup(sendParam, authInfo ? authInfo.accessToken:'');
                case 'MOD_COUNTER':
                    return putProjectPointCounter(sendParam, authInfo ? authInfo.accessToken:'');
                case 'DEL_COUNTER':
                    return deleteProjectPointCounter(sendParam, authInfo ? authInfo.accessToken:'');
                default :
                    return postProjectPointCounterAuto(sendParam, authInfo ? authInfo.accessToken:'');
            }
        },
        {
            onSuccess:()=>{
                queryClient.invalidateQueries([`${queryName}_POINT_COUNTER_LIST`], { refetchInactive: true });
            },
            onError:(err)=>{
                err.response.status===401 ? authExpired(queryClient)
                    : queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.message})
            }
        }
    )
}

const postProjectPointCounterAuto = async (param, accessToken) => {

    const sendParam = {
        tid: param.tid,
        dir_cnt: param.dir_cnt,
    }

    const retVal = await instance.post(contextPath+'/pointCounterAuto', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectPointCounterGroup = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/pointCounterGroup/'+param.tid+'/'+param.gno,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const postProjectPointCounter = async (param, accessToken) => {

    const sendParam = {
        tid: param.tid,
        gnm: param.gnm,
        gno: param.gno,
        counterArr: JSON.stringify(param.counterArr)
    }

    const retVal = await instance.post(contextPath+'/pointCounter', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const putProjectPointCounter = async (param, accessToken) => {

    const sendParam = {
        gno: param.gno,
        dir_no: param.dir_no,
        dir_nm: param.dir_nm
    }

    const retVal = await instance.put(contextPath+'/pointCounter', sendParam,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectPointCounterClear = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/pointCounterInit/'+param.tid,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}

const deleteProjectPointCounter = async (param, accessToken) => {
    const retVal = await instance.delete(contextPath+'/pointCounter/'+param.gno+'/'+param.dir_no,{headers:{Authorization:`Bearer ${accessToken}`}})
                                    .then((res)=>{
                                        return res;
                                    })
    return retVal;

}